/* eslint-disable react-hooks/exhaustive-deps */
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import { InversorModuloResponse, ListagemItem, OptionWithImage, Projeto } from "src/components/projetos/types";
import { checarNumeroMaximoDeInversores } from "src/components/projetos/utils/checarNumeroMaximoDeInversores";
import { ModalType, checarPotenciaTotal } from "src/components/projetos/utils/checarPotenciaTotal";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { setDimensionadoTabDisabledStatus, setDimensionadoTabDoneStatus } from "src/store/vendas/projetos/actions";
import theme from "src/theme/light";
import { INVERTER_MAX_POWER_ATTR, INVERTER_MAX_POWER_INPUT_ATTR } from "src/components/projetos/constants";
import { LayoutProjetoDimensionado } from "../../_layouts";
import { ALERT_BLOCK_INVERTERS, ALERT_MAX_INVERTERS, ALERT_MIN_INVERTERS, ALERT_MIN_MODULES, ALERT_POPUP_PARCEIRO, alertsList$, clearIntervalAlerts, setAlertsList, startIntervalAlerts, TAlertsDom } from "src/framework/store/ProcessarFilaMensagensStore";
import { FindInPageOutlined } from "@mui/icons-material";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import defaultListStore from "src/framework/store/DefaultListStore";
import { resolveUploadUrl } from "src/store/global.store";
import InversoresListMobile from "../../../containers/Mobile/InversoresListMobile";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { ID_MICROINVERSOR } from "src/components/componentes/types";

const MODELO_INVERSOR_DEFAULT = 'EGT';
const MODELO_INVERSOR_NOVO = 'IONS';
const MODELO_INVERSOR_RENOVGI = 'RGT';

interface InversoresProps {
  formState: Projeto;
  projetoOriginal?: Projeto;
  onChangeFormState: Dispatch<SetStateAction<Projeto>>
  onClickNext: () => void;
  onClickBack: () => void;
}

const useStyles = makeStyles({
  restoreButtonConfirm: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    }
  },
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  restoreButton: {
    backgroundColor: theme.palette.warning.dark,
    color: theme.palette.getContrastText(theme.palette.warning.dark),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    }
  }
})

const openItensAlert = (status: boolean, type?: ModalType): string | null => {
  if (status) {
    if (type === 'min-inverters') return ALERT_MIN_INVERTERS;
    if (type === 'min-modulos') return ALERT_MIN_MODULES;
  }

  return null;
}

const projetosProvider = new ProjetosProvider()
function Inversores({ formState, projetoOriginal, onChangeFormState, onClickNext, onClickBack }:InversoresProps) {
  const classes = useStyles();
  const [recalculado, setRecalculado] = useState<boolean>(false);
  const [atualizado, setAtualizado] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [fraseParceiroExibidoList] = useState<number[]>([]);
  const [disabledMensagemsInicializacao, setDisabledMensagemsInicializacao] = useState<boolean>(false);
  const [inversoresDisponivies, setInversoresDisponiveis] = useState<InversorModuloResponse[]>([]);
  const [selecionouModeloInversor, setSelecionouModeloInversor] = useState<string>('');

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const possuiIONS = useMemo(() => {
    const lista = inversoresDisponivies?.filter(i => i?.modelo?.toUpperCase()?.includes(MODELO_INVERSOR_NOVO)) || [];
    return !!lista?.length;
  },[inversoresDisponivies]);

  const possuiRGT = useMemo(() => {
    const lista = inversoresDisponivies?.filter(i => i?.modelo?.toUpperCase()?.includes(MODELO_INVERSOR_RENOVGI)) || [];
    return !!lista?.length;
  },[inversoresDisponivies]);
  
  const possuiEGT = useMemo(() => {
    const lista = inversoresDisponivies?.filter(i => i?.modelo?.toUpperCase()?.includes(MODELO_INVERSOR_DEFAULT)) || [];
    return !!lista?.length;
  },[inversoresDisponivies]);

  const MODELOS_INVERSOR_OPTIONS: OptionWithImage<string>[] = [
    {
      text: 'IONS',
      value: 'ions',
      disabled: false,
      image: ''
    },
    {
      text: 'RGT',
      value: 'rgt',
      disabled: false,
      image: ''
    },
    {
      text: 'EGT',
      value: 'egt',
      disabled: false,
      image: ''
    }
  ];

  const ionsOpt = MODELOS_INVERSOR_OPTIONS.find(item => item.value === 'ions')
  const rgtOpt = MODELOS_INVERSOR_OPTIONS.find(item => item.value === 'rgt')
  const egtOpt = MODELOS_INVERSOR_OPTIONS.find(item => item.value === 'egt')

  useEffect(() => {
    if (possuiIONS) {
      setFormState({ inversor_modelo: ionsOpt });

      if (ionsOpt) {
        setSelecionouModeloInversor(ionsOpt.value);
      }

      return;
    }

    if (possuiRGT) {
      setFormState({ inversor_modelo: rgtOpt });
      
      if (rgtOpt) {
        setSelecionouModeloInversor(rgtOpt.value);
      }

      return;
    }

    if (possuiEGT) {
      setFormState({ inversor_modelo: egtOpt });
      
      if (egtOpt) {
        setSelecionouModeloInversor(egtOpt.value);
      }
    }
  }, [possuiIONS, possuiRGT, possuiEGT]);

  useEffect(() => {
    clearIntervalAlerts();
    startIntervalAlerts();
  }, [])

  const setFormState = useCallback((newState: Partial<Projeto>)=>{
    onChangeFormState(old => ({...old, ...newState}))
  },[onChangeFormState])

  const buscarSugestaoInversores = useCallback(async()=>{
    const selectedModulo = formState.modulosList?.find(item => item.selecionado)
    if (!selectedModulo || !selecionouModeloInversor || !formState.inversor_modelo?.value) return;

    const potencia = selectedModulo?.potencia || 0;
    const quantidade = selectedModulo?.quantidade || 1;
    const potencia_total = Number((potencia / 1000.0 * quantidade).toFixed(2));
    const result = await projetosProvider.calcularInversores(selectedModulo.componente_id, {
      categoria_componentes_id: formState.tipo_inversor?.value || undefined,
      inversor_tensao: formState.tensao_rede?.value || 0,
      inversor_tipo_conexao: formState.numero_fases?.value || 0,
      total_modulos: selectedModulo.quantidade,
      potencia: potencia_total || Number(formState.potencia_desejada || 0),
      regioes: formState.regioes.map(item => item.id),
      segmento: formState.segmento?.includes("on") ? "on" : "off",
      inversor_modelo: formState.inversor_modelo?.value || "",
    })

    return result.data
  },[formState.modulosList, formState.tipo_inversor?.value, formState.tensao_rede?.value, formState.numero_fases?.value, formState.potencia_desejada, formState.regioes, formState.inversor_modelo?.value, selecionouModeloInversor])

  const buscarInversoresDisponiveis = useCallback(async()=>{
    const selectedModulo = formState.modulosList?.find(item => item.selecionado)
    if (!selectedModulo) return;

    const potencia = selectedModulo?.potencia || 0;
    const quantidade = selectedModulo?.quantidade || 1;
    const potencia_total = Number((potencia / 1000.0 * quantidade).toFixed(2));
    const result = await projetosProvider.listarInversores(selectedModulo.componente_id, {
      categoria_componentes_id: formState.tipo_inversor?.value || undefined,
      inversor_tensao: formState.tensao_rede?.value || 0,
      inversor_tipo_conexao: formState.numero_fases?.value || 0,
      total_modulos: selectedModulo.quantidade,
      potencia: potencia_total || Number(formState.potencia_desejada || 0),
      regioes: formState.regioes.map(item => item.id),
      segmento: formState.segmento?.includes("on") ? "on" : "off"
    })

    return result.data
  },[formState.modulosList, formState.tipo_inversor?.value, formState.tensao_rede?.value, formState.numero_fases?.value, formState.potencia_desejada, formState.regioes])

  const selectedModulo = useMemo(()=>{
    return formState.modulosList?.find(item => item.selecionado)
  },[formState.modulosList])

  const recalcularInversores = useMemo(()=>{
    if (recalculado) return true;
    if ((formState && projetoOriginal) && (
      formState.tipo_inversor !== projetoOriginal?.tipo_inversor ||
      formState.tensao_rede !== projetoOriginal?.tensao_rede ||
      formState.numero_fases !== projetoOriginal?.numero_fases ||
      Number(formState.potencia_desejada) !== Number(projetoOriginal?.potencia_desejada) ||
      formState.regioes !== projetoOriginal?.regioes ||
      (projetoOriginal?.inversor_modelo?.value && (formState.inversor_modelo?.value !== projetoOriginal?.inversor_modelo?.value))
    )) return true;
    return false;
  },[formState, projetoOriginal, recalculado])

  const restoreInverters = useCallback(() => {
    const sugestaoInversores = formState.sugestoes.inversores || []
    const newInversoresList = formState.inversoresList?.map((item) => {
      const sugestao = sugestaoInversores.find(sugestao => sugestao.id === item.componente_id)
      return {
        ...item,
        quantidade: sugestao?.quantidade || 0
      }
    })
    setRecalculado(true);
    setFormState({ inversoresList: newInversoresList })
  }, [formState.inversoresList, formState.sugestoes.inversores, setFormState])

  const checkTotalPowerIsInvalid = useCallback((inversoresList: ListagemItem[]): { status: boolean; type?: ModalType }  => {
    if (!selectedModulo) return { status: false }
    if (!inversoresList) return { status: false }
    return checarPotenciaTotal(selectedModulo, inversoresList)
  },[selectedModulo])

  useEffect(()=>{
    const selected = formState.modulosList?.find(item => item.selecionado)
    if (!selected || loading) return;

    setLoading(true);
    buscarSugestaoInversores().then(sug => {
      if (!sug) return;
      let _alertasList: TAlertsDom[] = alertsList$.getValue();
      const tipoInversor = formState.tipo_inversor?.value || 0
      const inversoresSugeridos = sug?.inversores || []

      const sugestoesAnteriores = formState.sugestoes?.inversores || []
      const filteredInversores = sug?.inversores?.filter(item => item.categoria_componentes_id === tipoInversor) || []
      const sortedInversores = filteredInversores?.sort((a, b) => {
        const potenciaA = a?.potencia_maxima_saida || Number(a?.atributos?.find(i => i.atributo === 'INVERSOR_POTENCIA_MAXIMA_SAIDA')?.valor);
        const potenciaB = b?.potencia_maxima_saida || Number(b?.atributos?.find(i => i.atributo === 'INVERSOR_POTENCIA_MAXIMA_SAIDA')?.valor);
        if (potenciaA === potenciaB) {
          return a.modelo.localeCompare(b.modelo);
        }
        return potenciaA - potenciaB;
      });

      let sugestaoMudou = false
      let result: ListagemItem[] = sortedInversores.map((inversor: InversorModuloResponse): ListagemItem => {
        const sugestao = inversoresSugeridos.find(item => item.id === inversor.id)
        const potencia = inversor.atributos.find(item => item.atributo === INVERTER_MAX_POWER_ATTR)
        const potenciaMaximaEntrada = inversor.atributos.find(item => item.atributo === INVERTER_MAX_POWER_INPUT_ATTR)
        const savedItem = formState.inversoresList?.find(item => item.componente_id === inversor.id)
        const sugestaoAnterior = sugestoesAnteriores.find(item => item.id === inversor.id)

        const getQuantidade = () => {
          if (formState?.retornou_tela && savedItem?.componente_id) return savedItem?.quantidade || 0;
          
          if (recalculado && !formState?.alterou_modulo && savedItem && formState?.isEdit) {
            return savedItem?.quantidade || 0;
          }

          if ((!recalcularInversores && !formState?.alterou_modulo) && (savedItem && formState?.isEdit)) {
            return savedItem?.quantidade || 0;
          }

          if (formState?.isEdit && !recalculado && !recalcularInversores && !formState?.alterou_modulo) {
            return savedItem?.quantidade || 0;
          }
          
          if (!savedItem) return sugestao?.quantidade || 0;
          if (recalcularInversores && formState?.isEdit) return sugestao?.quantidade || 0;
          if (savedItem?.componente_id !== sugestaoAnterior?.id) return savedItem.quantidade || 0;
          if (savedItem.quantidade !== sugestaoAnterior?.quantidade) return savedItem?.quantidade || 0
          if (sugestaoMudou || sugestaoAnterior?.quantidade !== sugestao?.quantidade) {
            sugestaoMudou = true
            return sugestao?.quantidade || 0
          };
          return savedItem.quantidade || 0
        }

        return {
          potenciaMaximaEntradaCC: Number(potenciaMaximaEntrada?.valor || 0),
          componente_id: inversor.id,
          nome: inversor.nome,
          modelo: inversor?.modelo,
          descricao: inversor.descricao,
          quantidade: getQuantidade(),
          altura: inversor.altura,
          largura: inversor.largura,
          peso: inversor.peso,
          valor: 0,
          categoria_componentes_id: inversor.categoria_componentes_id,
          potencia: Number(potencia?.valor || 0),
          valor_unitario: savedItem?.valor_unitario || 0,
          exibir_popup_parceiro: inversor.exibir_popup_parceiro,
        }
      })


      /*if (formState?.isEdit && !recalcularInversores) {
        const categoriaIds = [ID_INVERSOR, ID_MICROINVERSOR];
        const componentes = formState?.old_componentes_edicao;
        const sugestoes_inversores = formState?.sugestoes?.inversores;
        const inversoresIds = componentes?.filter(i => categoriaIds.includes(Number(i?.categoria_componentes_id)))?.map(i => i.id);
        const sugestoesIds = sugestoes_inversores?.map((i: any) => i.id);
        result = result?.filter(i => inversoresIds?.includes(Number(i?.componente_id)) || sugestoesIds?.includes(Number(i?.componente_id)))
          ?.map((i) => ({ 
            ...i, 
            quantidade: componentes?.find(ii => ii.id === i.componente_id)?.quantidade || 0 
          }));
      }*/
      
      if (formState?.isEdit && !recalculado && (result?.length && !result?.filter(i => i.quantidade > 0)?.length)) {
        restoreInverters();
      }

      if(!formState?.isEdit && !disabledMensagemsInicializacao) {
        const isExibirPopupParceiro = result?.some(i => i.exibir_popup_parceiro && i.quantidade > 0);
        if(isExibirPopupParceiro) {
          _alertasList.push({
            alert: ALERT_POPUP_PARCEIRO
          });
        }
      }
      const { status, type } = checkTotalPowerIsInvalid(result);
      if (!formState?.isEdit || (recalcularInversores && formState?.isEdit)) {
        const alerta = openItensAlert(status, type);
        if(alerta) {
          _alertasList.push({
            alert: alerta,
          });
        }
      }

      setDisabledMensagemsInicializacao(true);
      if(_alertasList && _alertasList.length) {
        setAlertsList(_alertasList);
      }

      setFormState({
        inversoresList: result?.sort((a, b) => a.potencia - b.potencia) || [],
        sugestoes: {
          ...formState.sugestoes,
          inversores: sug?.inversores?.map(item => ({ id: item.id, quantidade: item.quantidade, categoria_componentes_id: item.categoria_componentes_id, exibir_popup_parceiro: item.exibir_popup_parceiro })) || []
        }
      })

      setAtualizado(true);
      setLoading(false);
    }).catch(e => {
      setLoading(false);
    });
  },[checkTotalPowerIsInvalid, setFormState, buscarSugestaoInversores, recalcularInversores, recalculado])
  
  useEffect(()=>{
    const selected = formState.modulosList?.find(item => item.selecionado)
    if (!selected || loading) return;

    setLoading(true);
    buscarInversoresDisponiveis().then(sug => {
      const tipoInversor = formState.tipo_inversor?.value || 0

      const filteredInversores = sug?.inversores?.filter(item => item.categoria_componentes_id === tipoInversor) || []
      const sortedInversores = filteredInversores?.sort((a, b) => {
        const potenciaA = a?.potencia_maxima_saida || Number(a?.atributos?.find(i => i.atributo === 'INVERSOR_POTENCIA_MAXIMA_SAIDA')?.valor);
        const potenciaB = b?.potencia_maxima_saida || Number(b?.atributos?.find(i => i.atributo === 'INVERSOR_POTENCIA_MAXIMA_SAIDA')?.valor);
        if (potenciaA === potenciaB) {
          return a.modelo.localeCompare(b.modelo);
        }
        return potenciaA - potenciaB;
      });

      setInversoresDisponiveis(sortedInversores);
      setLoading(false);
    }).catch(e => {
      setLoading(false);
    });
  },[setFormState, buscarInversoresDisponiveis])
  
  useEffect(() => {
    if (((recalcularInversores || formState?.alterou_modulo) && formState?.isEdit) ||
      (recalcularInversores && formState?.alterou_modulo)) {
      if (!formState?.retornou_tela) restoreInverters()
    }
  }, [recalcularInversores, atualizado, formState?.alterou_modulo, formState?.retornou_tela, formState?.isEdit])

  const checkInverterQuantityIsInvalid = useCallback((id?: number)=>{
    if (formState.tipo_inversor?.value === ID_MICROINVERSOR) return false;
    return checarNumeroMaximoDeInversores(formState.inversoresList || [], id)
  },[formState.inversoresList])

  const handleChangeInverterQuantity = useCallback((id: number, value: string)=> {
    let _alertasList: TAlertsDom[] = alertsList$.getValue();

    const quantidade = Number(value || 0);
    let newInversoresList = formState.inversoresList?.map((item) => {
      if (item.componente_id === id) {
        item.quantidade = quantidade
      }
      return item
    })

    const selected = newInversoresList?.find(item => item.componente_id === id);

    if(selected?.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === id);
      if(idx < 0 && quantidade > 0) {
        _alertasList.push({
          alert: ALERT_POPUP_PARCEIRO,
        });
        fraseParceiroExibidoList.push(id);
      } else {
        if(quantidade === 0) {
          fraseParceiroExibidoList.splice(idx, 1);
        }
      }
    }

    // Verifica se a quantidade de inversores não ultrapassa o limite
    const isInvalid = checkInverterQuantityIsInvalid(id);
    if (isInvalid) {
      _alertasList.push({
        alert: ALERT_MAX_INVERTERS
      });
    }

    // Verifica limites de potência
    const { status, type } = checkTotalPowerIsInvalid(formState.inversoresList || []);
    const alerta = openItensAlert(status, type);
    if(alerta) {
      _alertasList.push({
        alert: alerta
      });
    }

    if(_alertasList && _alertasList.length) {
      setAlertsList(_alertasList);
    }

    setFormState({ inversoresList: newInversoresList?.sort((a, b) => a.potencia - b.potencia) })
  },[formState.inversoresList, checkInverterQuantityIsInvalid, checkTotalPowerIsInvalid, setFormState, loading])

  const handleRestore = useCallback(() => {
    confirmationDialog.setup({
      title:'Atenção',
      content: (
        <>
          <Box mb={2}>
            <Typography>
              <strong>Restauração dos inversores</strong>
            </Typography>
          </Box>

          <Typography>Você tem certeza que deseja restaurar os inversores?</Typography>
        </>
      ),
      onConfirmation: () => {
        restoreInverters();
      },
      onClose: () => confirmationDialog.close(),
      onNegation: () => confirmationDialog.close(),
      yesText: 'Restaurar',
      noText: 'Cancelar',
      submitButtonClassName: classes.restoreButtonConfirm
    })
    confirmationDialog.open()
  }, [classes.restoreButtonConfirm, restoreInverters])

  const nextButtonIsDisabled = useMemo(()=>{
    if (!formState.inversoresList?.length) return true;
    const inversorNaoAdicionado = formState?.inversoresList?.every(item => Number(item.quantidade || 0) <= 0)
    if (inversorNaoAdicionado) return true;
    if (checkTotalPowerIsInvalid(formState.inversoresList).status) return true
    if (checkInverterQuantityIsInvalid()) return true;
    if (!formState.inversor_modelo) return true;
    return false;
  },[formState.inversoresList, checkTotalPowerIsInvalid, checkInverterQuantityIsInvalid])

  useEffect(()=>{
    setDimensionadoTabDisabledStatus('solucao', nextButtonIsDisabled)
    setDimensionadoTabDoneStatus('inversores', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  useEffect(()=>{
    if (formState.inversoresList){
      const _inversores : ListagemItem[] = formState?.inversoresList?.sort((a, b) => a.potencia - b.potencia);
      setFormState({ inversoresList: _inversores })
    }
  },[formState.inversoresList])

  const renderInversores = useCallback(() => {
    if (isMobile) {
      return <InversoresListMobile 
        inversoresList={formState?.inversoresList || []}
        handleChangeInverterQuantity={handleChangeInverterQuantity}
      />
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              <TableCell align='left'><strong>Inversor</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formState.inversoresList?.map((row) => (
              <TableRow key={row.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box textAlign={'left'}>
                    <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                      {row.nome}
                    </Typography>
                    <Typography variant='body2' color='textSecondary'>
                      <span className={classes.warningText}>Informações</span>: {row.descricao}
                    </Typography>
                  </Box>
                </TableCell>

                <TableCell align='center' component="th">
                  <Box width="180px" margin={"0 auto"}>
                    <InputQuantidade value={row.quantidade} onChange={(v: any) => handleChangeInverterQuantity(row.componente_id, v)} />
                  </Box>
                </TableCell>

                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton
                      onClick={() => row.componente_id && modalComponentesDetalhesData$.next(row.componente_id)}
                      size="large">
                        <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [classes, handleChangeInverterQuantity, formState.inversoresList])

  return (
    <LayoutProjetoDimensionado
      formState={formState}
      onClickBack={() => {
        setFormState({ alterou_modulo: false })
        setFormState({ retornou_tela: false })
        onClickBack()
      }}
      onClickNext={() => {
        setFormState({ retornou_tela: false })
        onClickNext();
      }}
      nextButtonIsDisabled={nextButtonIsDisabled}
      title="Sugestão de inversores para você!"
      subtitle={(
        <ul style={{ paddingLeft: 16 }}>
          <li>Verificar as informações contidas na descrição dos inversores sugeridos.</li>
          <li>Recomendamos verificar se os inversores respeitam a tensão, o número e o balanceamento de fases conforme exigências da concessionária local.</li>
          <li>Garantir que no local de instalação do micro/inversor exista um bom nível de sinal Wi-Fi para que o monitoramento opere de forma correta.</li>
        </ul>
      )}>
        <Box p={2}>
          {!!selecionouModeloInversor && (
            <>
              { renderInversores() }
              <Box mt={4} className="row" display="flex" justifyContent={"flex-end"}>
                <Button variant="contained" onClick={handleRestore} className={classes.restoreButton} fullWidth={isMobile}>Restaurar Inversores</Button>
              </Box>
            </>
          )}

        </Box>
    </LayoutProjetoDimensionado>
  )
}
export { Inversores }